<div class="topbar-area home9-topbar dark-bar">
  <div class="container">
    <div class="row y-middle">
      <div class="col-md-7">
        <ul class="topbar-contact">
          <li>
            Near RTC Bus Stand , Ananthapuramu-515001
          </li>
          <li>
            <i class="flaticon-phone"></i> 08554 - 232268 / 243366

          </li>
          <li>
            <i class="flaticon-email"></i>
            <a href="mailto:info@sbesatp.org"> &nbsp;info@sbesatp.org</a>
          </li>
          <li>
           
        </ul>
      </div>
      <div class="col-md-5 text-right">
        <ul class="topbar-right">
         
          <li class="btn-part">
            <a class="apply-btn"  href="https://www.sbescampus.in/">Sbes E-Campus</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
